/*
  AULBERY — Transparent pricing (sections/as-transparent-pricing.liquid)
  Moved 1:1 from the section's inline <script>. The currency codes, locale
  fallback and currency display style are read from data-* attributes on the
  [data-as-tp] root. The formatting logic is unchanged. Because the script now
  loads deferred, the Intl re-format runs after parsing instead of inline —
  the Liquid-rendered figures are on screen until then.
*/
(function () {
  if (window.ASTpBooted) return;
  window.ASTpBooted = true;

  function initPricing(root) {
    if (!root || root.dataset.asxInit === '1') return;
    root.dataset.asxInit = '1';

    var currencyCode = root.dataset.currencyCode;
    var storeCurrency = root.dataset.storeCurrency;
    var locale = document.documentElement.lang || (root.dataset.langFallback || 'en');
    var currencyDisplay = root.dataset.currencyDisplay || 'narrowSymbol';
    var shopifyCurrency = window.Shopify && window.Shopify.currency ? window.Shopify.currency : null;
    var marketRate = shopifyCurrency ? parseFloat(shopifyCurrency.rate) : 1;
    if (!isFinite(marketRate) || marketRate <= 0) marketRate = 1;

    root.querySelectorAll('[data-asx-money]').forEach(function (node) {
      var amount = parseFloat(node.getAttribute('data-asx-value'));
      if (!isFinite(amount)) return;

      // Product prices supplied by Shopify are already in the customer's
      // presentment currency. Manually entered figures begin in the store's
      // base currency and use Shopify Markets' active conversion rate.
      if (node.getAttribute('data-asx-source') === 'base' && currencyCode !== storeCurrency) {
        amount *= marketRate;
      }

      var whole = node.getAttribute('data-asx-whole') === 'true';
      var options = {
        style: 'currency',
        currency: currencyCode,
        currencyDisplay: currencyDisplay
      };
      if (whole) {
        options.minimumFractionDigits = 0;
        options.maximumFractionDigits = 0;
      }
      try {
        node.textContent = new Intl.NumberFormat(locale, options).format(amount);
      } catch (error) {
        node.textContent = currencyCode + ' ' + amount.toFixed(whole ? 0 : 2);
      }
    });
  }

  function initAll() {
    var roots = document.querySelectorAll('[data-as-tp]');
    for (var i = 0; i < roots.length; i++) initPricing(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();

